import statusbar from 'url:../../../assets/images/home-progress-0.webp';
import trainers1 from 'url:../../../assets/images/trainers-1.webp';
import trainers2 from 'url:../../../assets/images/trainers-2.webp';
import trainers3 from 'url:../../../assets/images/trainers-3.webp';
import trainers4 from 'url:../../../assets/images/trainers-4.webp';
import trainers5 from 'url:../../../assets/images/trainers-5.webp';
import trainers6 from 'url:../../../assets/images/trainers-6.webp';
import trainers7 from 'url:../../../assets/images/trainers-7.webp';
import tabBar from 'url:../../../assets/images/trainers-8.webp';

export const trainersAssets = {
  statusbar,
  trainers1,
  trainers2,
  trainers3,
  trainers4,
  trainers5,
  trainers6,
  trainers7,
  tabBar,
} as const;

export const trainersAssetList = Object.values(trainersAssets);
